import { getRestorationZoneDemandRestoredJsonData } from "api/dataVisualisation/restorationZone/restorationZoneDemandRestored";
import { Region } from "components/dataVisualization/restorationZone/RegionFilter";
import useRequest, { RequestStatus } from "hooks/useRequest";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { RestorationZoneDemandRestoredModel } from "models/restorationZone/restorationZoneDemandRestored";
import { useCallback } from "react";

const useRestorationZoneDemandRestoredData = (
  dateFilter: DateFilterModel,
  regionFilter: Region
): {
  fetchData: () => void;
  data: RestorationZoneDemandRestoredModel[] | null;
  status: RequestStatus;
} => {
  const {
    data: jsonData,
    status,
    request: fetchRestorationZoneDemandRestoredData,
  } = useRequest(getRestorationZoneDemandRestoredJsonData);

  const fetchData = useCallback(() => {
    fetchRestorationZoneDemandRestoredData(dateFilter, regionFilter);
  }, [dateFilter, regionFilter, fetchRestorationZoneDemandRestoredData]);

  return {
    data: jsonData?.data ?? null,
    status,
    fetchData,
  };
};

export default useRestorationZoneDemandRestoredData;
